import { StatsigClient } from '@statsig/js-client';

// Set the userID on the running Statsig client early (e.g. the signup user_id, before it
// reaches authStore) so signup exposures carry a valid unit. Fire-and-forget; no-ops until
// the client exists.
export async function setStatsigUserId(userID: string): Promise<void> {
    const client = StatsigClient.instance();
    if (!userID || !client) return;
    const { stableID } = client.getContext();
    try {
        await client.updateUserAsync({
            userID,
            ...(stableID != null && { customIDs: { stableID } }),
        });
    } catch {
        // swallow: a failed telemetry update must not reject the caller
    }
}
